import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { ItemDetailComponent } from '../../components/item-detail/item-detail.component';
import { ItemDetailConfig } from '../../components/item-detail/item-detail.types';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { ConferenceService } from '../../services/conference.service';
import { ConferenceDto } from '../../dto/conference.dto';
import { AuthService } from '../../services/auth.service';
import { ProcessResult, QueryOptions } from '../../components/common-dto/query.dto';
import { Params } from '@angular/router';

@Component({
  selector: 'app-conference-detail',
  standalone: true,
  imports: [CommonModule, ItemDetailComponent, ToastModule],
  providers: [MessageService],
  template: `<pb-item-detail [config]="detailConfig"></pb-item-detail>`,
})
export class ConferenceDetailComponent {
  detailConfig: ItemDetailConfig = {
    header: 'Conference Details',
    isEditable: true,
    supportsAdd: true,
    supportsDelete: false,
    updateSuccessMessage: 'Conference updated successfully',
    createSuccessMessage: 'Conference created successfully',
    breadcrumbField: 'name',
    formLayout: [
      {
        key: 'name',
        label: 'Conference Name',
        type: 'text',
        required: true,
      },
      {
        key: 'location',
        label: 'Location',
        type: 'text',
        required: true,
      },
      {
        key: 'date',
        label: 'Date',
        type: 'date',
        required: true,
      },
      {
        key: 'startDate',
        label: 'Start Date & Time',
        type: 'date',
        required: false,
      },
      {
        key: 'endDate',
        label: 'End Date & Time',
        type: 'date',
        required: false,
      },
    ],
    dataService: {
      parseParams: (params: Params, queryParams: Params) => ({
        id: params['id'],
        isNew: params['id'] === 'new',
      }),
      loadItem: (params: QueryOptions) => {
        if (params.isNew) {
          // Return empty conference for new
          return of({
            name: '',
            location: '',
            date: new Date(),
            startDate: undefined,
            endDate: undefined,
          } as ConferenceDto);
        }
        return this.conferenceService.getConference(params.id || '');
      },
      createItem: (params: QueryOptions, item: any) => {
        return this.conferenceService.createConference(item);
      },
      updateItem: (params: QueryOptions, item: any) => {
        // For now, just return success - update can be added later if needed
        return of({
          success: true,
          message: 'Conference updated successfully',
          id: params.id,
        } as ProcessResult);
      },
      deleteItem: (params: QueryOptions) => {
        // For now, just return success - delete can be added later if needed
        return of({
          success: true,
          message: 'Conference deleted successfully',
          id: params.id,
        } as ProcessResult);
      },
    },
  };

  constructor(
    private conferenceService: ConferenceService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router
  ) {}
}

